import React from "react";
import Input from "Components/UI/Input";
import { useFormContext } from "react-hook-form";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import dayjs from "dayjs";
const isStatusOption = [
  { id: 1, label: "Yes", value: true },
  { id: 0, label: "No", value: false },
];
const EditAdditionDeductionModal = ({
  onSubmit,
  show = false,
  handleClose,
}) => {
  return (
    <Modal show={show} onHide={handleClose} animation={true} centered size="lg">
      <Modal.Header
        className="modal-header border-0 custom-modal-header"
        style={{ justifyContent: "space-between" }}
      >
        <div className="page-title">
          <h4>Update Additions and Deductions</h4>
        </div>
        <button type="button" className="close" onClick={handleClose}>
          <span aria-hidden="true">×</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={onSubmit} className="needs-validation">
          <div className="form-row row">
            <div className="col-lg-6 col-md-6 col-sm-12 col-6">
              <h5 className="view-sub-title">Allowance</h5>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 col-6">
              <h5 className="view-sub-title">Deduction</h5>
            </div>
            {/* <div className="mb-3"> */}
            {/* <Input
                name="advancePaymentDetails.installmentDate"
                type="date"
                placeholder="Installment Date"
                className={`form-control ${
                  errors?.advancePaymentDetails?.installmentDate
                    ? "is-invalid"
                    : ""
                }`}
                label="Installment Date"
                labelClassName="form-label"
                required={true}
                requiredMessage="Installment date is required"
                defaultValue=""
                dateFormat="YYYY-MM-DD"
                getPopupContainer={(trigger) => trigger.parentNode}
                // disabledDate={(current) => {
                //   return current < dayjs().subtract(1, "day").endOf("day");
                // }}
              /> */}
            {/* </div> */}
          </div>
          <div className="text-end mt-3">
            <button type="submit" className="btn btn-primary">
              Save
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

EditAdditionDeductionModal.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default EditAdditionDeductionModal;
